module.exports = "//static.hsappstatic.net/salesImages/static-1.403/settings-images/calling-icon.png"